import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-grid',
  templateUrl: './sms-grid.component.html',
  styleUrls: ['./sms-grid.component.css']
})
export class SmsGridComponent implements OnInit {
  title="Location based SMS";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/smsby-location/sms-grid/sms-grid.component.ts